import { render, staticRenderFns } from "./AdminReport.vue?vue&type=template&id=74c7f3d4&scoped=true"
import script from "./AdminReport.vue?vue&type=script&lang=js"
export * from "./AdminReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74c7f3d4",
  null
  
)

export default component.exports